// extracted by mini-css-extract-plugin
export var fadeIn = "_jg-1";
export var modalContent = "_jg-3";
export var overlay = "_jg-0";
export var popoverContent = "_jg-2";
export var results = "_jg-5";
export var searchInputWrapper = "_jg-4";